(() => {
 function init(root=document){
  root.querySelectorAll('.tbc-v3-steps .tbc-v3-rail').forEach(rail=>{
   if(rail.dataset.guestbookReady)return;
   rail.dataset.guestbookReady='true';
   rail.addEventListener('keydown',event=>{
    if(event.target!==rail||!matchMedia('(max-width:768px)').matches||!['ArrowLeft','ArrowRight'].includes(event.key))return;
    event.preventDefault();
    const card=rail.firstElementChild;if(!card)return;
    rail.scrollBy({left:(card.getBoundingClientRect().width+14)*(event.key==='ArrowRight'?1:-1),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
   });
  });
 }
 init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();
